import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountDetailsModel } from '../shared/models/account.model';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AccountResolverService  {

  constructor(private accountService: AccountService) { }

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<AccountDetailsModel> {
    return this.accountService.getCurrentUserAccount();
  }
}
